import React, { FC } from 'react'

const ThumbsDownOutlinedIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M3.77329 0H10.7805V7.67799L6.40405 12L6.09554 11.6915C6.03225 11.6277 5.97874 11.5463 5.935 11.4472C5.89126 11.3481 5.86962 11.2566 5.87008 11.1729V11.0633L6.58414 7.67799H1.73304C1.44128 7.67799 1.18069 7.56282 0.951283 7.33248C0.720944 7.10307 0.605774 6.84249 0.605774 6.55072V5.69148C0.605774 5.62773 0.612754 5.55817 0.626714 5.48278C0.641605 5.40786 0.660683 5.33853 0.68395 5.27478L2.58949 0.756631C2.68535 0.542113 2.84658 0.362261 3.0732 0.217078C3.29935 0.0723592 3.53272 0 3.77329 0ZM10.0825 0.697999H3.77329C3.67511 0.697999 3.5746 0.724756 3.47176 0.778269C3.36892 0.831782 3.29051 0.921359 3.23653 1.047L1.30377 5.58399V6.55002C1.30377 6.67566 1.34402 6.77873 1.42453 6.85924C1.50503 6.93974 1.60787 6.97999 1.73304 6.97999H7.45175L6.64347 10.7918L10.0825 7.37994V0.697999ZM10.7805 7.67799V6.97999H13.1698V0.697999H10.7805V0H13.8678V7.67799H10.7805Z"
        />
    </svg>
)

export default ThumbsDownOutlinedIcon
